var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":require("@/assets/images/giphy.gif"),"width":"60px"}}),_c('p',{staticClass:"mt-3"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }